import { call, put, takeLatest, select } from 'redux-saga/effects';
import { TemplateActionType } from '../../actions/template/template-actions';
import TemplateProvider from '../../../data/providers/template-provider';
import { startTemplateError } from '../../actions/template/template-action-creators';
import { getArmAccessTokenSaga } from '../identity/access-tokens';
import MlClientError, { FailureOperation } from '../../../data/ml-client-error';
import { getLocale, getLanguage } from '../../selectors/common-selectors';
export function* startTemplate(action) {
    try {
        const { templateId } = action;
        const accessToken = yield call(getArmAccessTokenSaga);
        const locale = yield select(getLocale);
        const language = yield select(getLanguage);
        yield call(TemplateProvider.startTemplate, templateId, accessToken, locale, language);
    }
    catch (e) {
        const error = new MlClientError(e ? e.message : undefined, action.templateId, FailureOperation.StartTemplate, e ? e.code : undefined);
        yield put(startTemplateError(error));
    }
}
export function* startTemplateSaga() {
    yield takeLatest(TemplateActionType.START_TEMPLATE, startTemplate);
}
